// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"9882d708","847":"46528762"}[chunkId] + ".chunk.css";
};